export const GET_CLIENTS = "GET_CLIENTS";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";

// ===================================================
// ===================================================

export const GET_SINGLE_CLIENT = "GET_SINGLE_CLIENT";
export const GET_SINGLE_CLIENT_SUCCESS = "GET_SINGLE_CLIENT_SUCCESS";
export const GET_SINGLE_CLIENT_FAILURE = "GET_SINGLE_CLIENT_FAILURE";

// ===================================================
// ===================================================

export const CREATE_CLIENT = "CREATE_CLIENT";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const CREATE_CLIENT_FAILURE = "CREATE_CLIENT_FAILURE";

// ===================================================
// ===================================================

export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS";
export const UPDATE_CLIENT_FAILURE = "UPDATE_CLIENT_FAILURE";

// ===================================================
// ===================================================

export const DELETE_CLIENT = "DELETE_CLIENT";
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";
export const DELETE_CLIENT_FAILURE = "DELETE_CLIENT_FAILURE";

// ===================================================
// ===================================================
